import axios from "axios";
import { buildApiUrl } from "./Static";
import { normalizeLoginResponse } from "./loginAccount";

export default async function registerAccount({
  userName,
  email,
  password,
  brand = "",
  userType = "designer",
}) {
  const payload = {
    userName: String(userName || "").trim(),
    email: String(email || "").trim().toLowerCase(),
    password,
    brand: String(brand || "").trim().toLowerCase(),
    userType,
  };

  const { data: response } = await axios.post(buildApiUrl("/register"), payload);
  return normalizeLoginResponse(response) || response;
}

export const registerErrorMessage = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const serverMessage =
    (typeof data === "string" && data) ||
    data?.message ||
    data?.error ||
    data?.msg;

  if (status === 409) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "An account with this email already exists.";
  }

  if (status === 400) {
    return typeof serverMessage === "string" && serverMessage.trim()
      ? serverMessage
      : "Please check the registration details and try again.";
  }

  if (typeof serverMessage === "string" && serverMessage.trim()) {
    return serverMessage;
  }

  if (error?.message === "Network Error") {
    return "Unable to reach the registration service. The API endpoint may not be live yet.";
  }

  return "Unable to create this account. Please try again.";
};
